import Immutable from 'seamless-immutable';
import { getMutable } from '../../common/Utils';
import _ from 'lodash';

/**
 * Domain
 * @typedef {object} Domain
 * @property {string} id domain id
 * @property {string} createdBy user name of record creator
 * @property {string} description domain description
 * @property {string} lastUpdated when the record was last updated
 * @property {string} dateCreated date of record creation
 * @property {string} modifiedBy user name of last person to update record
 * @property {string} name domain name
 * @property {string} tenantId account id
 *
 **/

/**
 * Create an domain from provided data
 */
function create(data = {}) {
  const result = _.clone(data);
  return Immutable(result, { prototype: model });
}

function deserialize(domain) {
  const result = _.pick(domain, _keys);
  return create(result);
}

function serialize(domain) {
  const result = getMutable(domain, { deep: true });
  return _.pick(result, _keys);
}

/** The domain prototype */
const model = {
  get value() {
    // handy for singleselect components to have easier access to this
    return this.name;
  },
};

/**
 * An array of keys on the domain object that should be shared between the API requests and responses
 */
const _keys = ['id', 'createdBy', 'description', 'lastUpdated', 'dateCreated', 'modifiedBy', 'name', 'tenantId'];

export default {
  create,
  deserialize,
  serialize,
};
